export const paymentCn = {
    gxzfcg:"恭喜您，订单支付成功！",
    fhdd:"点击跳转到检测服务订单列表",
    djfh:"返回服务订单"
}


// WEBPACK FOOTER //
// ./src/lang/home/payment/indexCn.js